/**
 * Upsell card — keeps the price column and the thumbnail in step with the
 * variant <select>.
 *
 * Shared by the PDP `upsell` block and the cart drawer, both of which emit a
 * <script src> for this file. A duplicate src is fetched once but executed
 * twice, hence the one-time flag.
 *
 * The <select> IS the form's `name="id"` input, so the cart add needs no help
 * from us — this only syncs the displayed price. Every money string is
 * pre-rendered onto its own <option> in Liquid, because `money` is market- and
 * locale-aware and has no JS equivalent here.
 *
 * The listener is delegated on `document` because the cart drawer replaces its
 * whole inner DOM on every cart change; a listener bound to a card would not
 * survive that.
 */
(() => {
  if (window.__anewUpsellCardInit) return;
  window.__anewUpsellCardInit = true;

  function setField(card, selector, text) {
    const el = card.querySelector(selector);
    if (!el) return;
    const value = (text || '').trim();
    el.textContent = value;
    el.toggleAttribute('hidden', value === '');
  }

  document.addEventListener('change', (e) => {
    const select = e.target.closest('[data-anew-upsell-select]');
    if (!select) return;
    const card = select.closest('[data-anew-upsell]');
    if (!card) return;
    const option = select.options[select.selectedIndex];
    if (!option) return;
    setField(card, '[data-anew-upsell-now]', option.dataset.price);
    setField(card, '[data-anew-upsell-was]', option.dataset.compare);
    setField(card, '[data-anew-upsell-save]', option.dataset.save);

    const thumb = card.querySelector('.anew-upsell-card__thumb');
    if (thumb && option.dataset.imageSrc && thumb.getAttribute('src') !== option.dataset.imageSrc) {
      // srcset first: with it still pointing at the old image, the browser
      // would keep picking from it whatever src says.
      thumb.srcset = option.dataset.imageSrcset || '';
      thumb.src = option.dataset.imageSrc;
    }
  });
})();
